import { Controller } from "stimulus";
import UserService from "../entrypoints/src/admin/services/user-service";
import AjaxLoader from "../entrypoints/src/admin/utilities/ajax-loader";
import sweet_alert from "../entrypoints/src/admin/utilities/sweet_alert";

export default class extends Controller {
  connect() {
		this.$resetPasswordModal = document.querySelector('.modal.user-reset-password-modal');
		this.userId = this.element.dataset.userId;
		this.$inPassword = this.$resetPasswordModal.querySelector('input[name="password"]')
		this.$inPasswordConfirmation = this.$resetPasswordModal.querySelector('input[name="password_confirmation"]')

		$(this.element.querySelectorAll('input')).on('keypress',  (ev) => {
      if (ev.code === 'NumpadEnter' || ev.code === 'Enter') {
				this.validateUserPasswords() && this.redefinePassword();
			}
		});

		this.$resetPasswordModal.querySelector('button.redefine-password').addEventListener('click', (ev) => {
			ev.preventDefault();
			this.validateUserPasswords() && this.redefinePassword();
		});
	}

	validateUserPasswords() {
		if (this.$inPassword.value == this.$inPasswordConfirmation.value)
			return true;

		this.resetErrors() && this.parseErrorObject({
			'password': ['senha deve ser igual a confirmação'],
			'password_confirmation': ['confirmação de senha deve ser igual a senha']
		});
	}

	async redefinePassword() {
		try {
			AjaxLoader.show();

			this.resetErrors();
			let response = await UserService.redefinePassword(this.userId, this.$inPassword.value, this.$inPasswordConfirmation.value);

			AjaxLoader.hide();

			if (response.hasOwnProperty('email'))
				return sweet_alert.fire({
					title: 'Pronto',
					text: 'Senha foi redefinida com sucesso!',
					icon: 'success'
				}).then(() => window.location.reload());

			this.parseErrorObject(response);
		} catch(ex) {
			AjaxLoader.hide();
			sweet_alert.fire({
				title: 'Atenção',
				text: 'Não foi possível redefinir a senha do usuário',
				icon: 'error'
			});
		}
	}

	resetErrors() {
		this.$resetPasswordModal.querySelectorAll('.form-group').forEach(($el) => {
			try {
				$el.classList.toggle('error', false);
				$el.classList.toggle('has-error', false);
				$el.querySelector('.help-block').remove();
			} catch(ex) {}
		});

		return true;
	}

	parseErrorObject(response) {
		Object.keys(response).forEach((key) => {
			let $formGroup = this.$resetPasswordModal.querySelector(`[name="${key}"]`).closest('.form-group');
			$formGroup.classList.toggle('error', true);
			$formGroup.classList.toggle('has-error', true);
			$formGroup.insertAdjacentHTML('beforeend', `<span class="help-block">${response[key].join(', ')}</span>`);
		});

		sweet_alert.fire({
			title: 'Atenção',
			text: 'Corrija os erros informados para continuar',
			icon: 'error'
		});
	}
}